import { render, staticRenderFns } from "./field-lastname.vue?vue&type=template&id=22b4bd22&"
import script from "./field-lastname.vue?vue&type=script&lang=js&"
export * from "./field-lastname.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports